import { render } from "./RequestsLink.vue?vue&type=template&id=622e644a"
import script from "./RequestsLink.vue?vue&type=script&lang=js"
export * from "./RequestsLink.vue?vue&type=script&lang=js"

import "./RequestsLink.vue?vue&type=style&index=0&id=622e644a&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__